import ContentAsset from "@components/BasicComponents/ContentAsset/ContentAsset"
import Separator from "@components/CustomTypography/Separator/Separator"
import {AdvancedSideAssetMainContent} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

type Props = {
	data: AdvancedSideAssetMainContent
}

const WebstoreIntroSection = (props: Props) => {
	return (
		<>
			<Separator size={32} />
			<ContentAsset
				contentProps={{
					size: "M",
					titleProps: {
						capitalize: false,
					},
					contentProps: {
						withoutHtml: false,
					},
				}}
				data={props.data}
			/>
		</>
	)
}

export default WebstoreIntroSection
